{
  "it": {
    "lot": {
      "attributes": {
        "end_date": "Data di fine",
        "internal_note": "Nota interna del lotto",
        "land_register": "Catasto",
        "name": "Nome",
        "start_date": "Data di inizio",
        "surface": "Superficie"
      },
      "labels": {
        "lot": "Nessun lotto | Un lotto | {count} lotti"
      },
      "toasts": {
        "create": "Lotto creato",
        "delete": "Lotto eliminato",
        "update": "Lotto aggiornato"
      },
      "validation": {
        "needName": "Il titolo è obbligatorio",
        "needNumber": "Deve essere un numero (ad es. 85)"
      }
    }
  }
}
